<script>
  import { createPopper } from "@popperjs/core";
  import { onMount, onDestroy } from "svelte";
  import { initializeAuth } from '../../lib/authStore.js';
  import { navigate } from "svelte-routing";
  import pb from '../../lib/pocketbase';
  import { subscribeSafe, unsubscribeSafe, onAuthChanged } from '../../lib/realtime.js';

  let dropdownPopoverShow = false;
  let btnDropdownRef;
  let popoverDropdownRef;
  let userData = null;
  let avatarUrl = null;
  let avatarFailed = false;
  let removeAuthListener = () => {};

  function buildAvatarUrl(user) {
    if (!user?.avatar) return null;
    try {
      return pb.files.getURL(user, user.avatar, { thumb: '100x100' });
    } catch {
      return null;
    }
  }

  function getInitials(user) {
    if (!user) return '?';
    const name = (user.name || user.email || '').trim();
    if (!name) return '?';
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }

  const toggleDropdown = (event) => {
    event.preventDefault();
    dropdownPopoverShow = !dropdownPopoverShow;
    if (dropdownPopoverShow) {
      createPopper(btnDropdownRef, popoverDropdownRef, {
        placement: "bottom-start",
      });
    }
  };

  onMount(async () => {
    await initializeAuth();
    const user = localStorage.getItem('pb_user');
    if (!user) return;

    try {
      userData = JSON.parse(user);
      avatarUrl = buildAvatarUrl(userData);
      avatarFailed = false;
    } catch {
      userData = null;
      avatarUrl = null;
    }

    subscribeToRealtime();
    removeAuthListener = onAuthChanged(() => {
      subscribeToRealtime();
    });
  });

  async function subscribeToRealtime() {
    await subscribeSafe('users', '*', (e) => {
      if (e.action === 'update' && userData && e.record.id === userData.id) {
        userData = e.record;
        avatarUrl = buildAvatarUrl(userData);
        avatarFailed = false;
      }
    });
  }

  onDestroy(() => {
    removeAuthListener();
    unsubscribeSafe('users', '*');
  });

  function logout() {
    localStorage.removeItem('pb_token');
    localStorage.removeItem('pb_user');
    localStorage.removeItem('pb_user_role');
    localStorage.removeItem('pocketbase_auth');
    navigate('/auth/login');
  }

  function handleAvatarError() {
    avatarFailed = true;
  }
</script>

<div>
  <a
    class="text-blueGray-500 block"
    href="#erpsys"
    bind:this="{btnDropdownRef}"
    on:click="{toggleDropdown}"
  >
    <div class="items-center flex">
      <span
        class="w-12 h-12 text-sm inline-flex items-center justify-center rounded-full overflow-hidden shadow-lg"
        class:bg-teal-500={!avatarUrl || avatarFailed}
        class:text-white={!avatarUrl || avatarFailed}
        class:bg-blueGray-200={avatarUrl && !avatarFailed}
      >
        {#if avatarUrl && !avatarFailed}
          <img
            alt={userData?.name || 'Usuario'}
            class="w-full h-full object-cover"
            src={avatarUrl}
            on:error={handleAvatarError}
          />
        {:else}
          <span class="font-semibold text-sm tracking-wide">{getInitials(userData)}</span>
        {/if}
      </span>
    </div>
  </a>
  <div
    bind:this="{popoverDropdownRef}"
    class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48 {dropdownPopoverShow ? 'block':'hidden'}"
  >
    <a
      href="#erpsys" on:click={(e) => e.preventDefault()}
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Action
    </a>
    <a
      href="#erpsys" on:click={(e) => e.preventDefault()}
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Another action
    </a>
    <a
      href="#erpsys" on:click={(e) => e.preventDefault()}
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Something else here
    </a>
    <div class="h-0 my-2 border border-solid border-blueGray-100" />
    <a
      href="#erpsys" on:click={logout}
      class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      Cerrar sesión
    </a>
  </div>
</div>
